import React from 'react';
import DatePicker, { DatePickerProps } from '.';
import useClassrooms from '@teetsh/app/src/containers/App/context/ClassroomsContext/useClassrooms';
import { getMutualWorkingDays } from '@teetsh/app/src/containers/utils';
import { Classroom } from '@teetsh/app/src/types/classroom';

export function SchoolDatePicker(
  props: DatePickerProps & {
    classrooms?: Classroom[];
  },
) {
  const allClassrooms = useClassrooms();
  const workingDays = getMutualWorkingDays(
    props.classrooms || allClassrooms,
  ).map(w => (w + 1) % 7);
  return (
    <DatePicker
      {...props}
      disabledDays={[0, 1, 2, 3, 4, 5, 6].filter(d => !workingDays.includes(d))}
    />
  );
}
